module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門3_1.08a74437.png";